






























import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogBox from '@/components/dialog-box/DialogBox.vue';
import { Quantity } from '@/model/Quantity';
import humanReadableQuantity from '@/filters/QuantityFormatter';
import ChangeQuantity from '@/components/orders/ChangeQuantity.vue';
import { SerializationHelper } from '@/helpers/SerializationHelper';

@Component({
    components: { DialogBox, ChangeQuantity },
    filters: { humanReadableQuantity }
})
export default class ProcessedQuantityDialog extends Vue {
    @Prop({ default: false }) isDialogOpen: boolean;
    @Prop({ default: "" }) orderNumber: string;
    @Prop({ default: {} }) quantity: Quantity;
    @Prop({ default: 'Confirmer' }) confirmText: string;
    @Prop({ default: 'Annuler' }) cancelText: string;
    @Prop({ default: 'Confirmer la quantité préparée pour la commande ' }) title: string;

    public processedQuantity: Quantity = new Quantity();

    mounted() {
        this.processedQuantity = SerializationHelper.toInstanceFromJsonObj(new Quantity(), this.quantity);
    }

    confirm() {
        this.$emit('confirm', this.processedQuantity);
    }

    cancel() {
        this.$emit('cancel');
    }

    get isProcessedQuantityInferiorToOrderedQuantity(): boolean {
        return this.processedQuantity.value < this.quantity.value;
    }
}
